import { default as Home } from "./home-root";

export default Home;
